import { Column, Index } from 'typeorm';

import { ApiProperty } from '../../codegen';
import {
  IsBoolean,
  IsDate,
  IsNumber,
  IsObject,
  IsOptional,
} from '../../validators';
import { BasicEntity } from '../basic/basic.entity';

@Index(['userId'], { unique: true })
export class UserSecurityState extends BasicEntity {
  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false })
  userId: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  suspiciousScoreMilli: number;

  @ApiProperty()
  @IsBoolean({ groups: ['error'] })
  @Column({ type: 'boolean', nullable: false, default: false })
  isSuspicious: boolean;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  linkedBannedUsersCount: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  linkedIpsCount: number;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsDate({ groups: ['error'] })
  @Column({ type: 'timestamptz', nullable: true, precision: 3 })
  latestMatchedAt?: Date | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsObject({ groups: ['error'] })
  @Column({ type: 'jsonb', nullable: true })
  latestEvidenceJson?: Record<string, unknown> | null;
}
